const Status = [
  { label: "未領取", value: "wait_collect", tagColor: "red" },
  { label: "已領取", value: "collected", tagColor: null }
];

const Type = [
  { label: "寄物", value: "sender" },
  { label: "取物", value: "recipient" }
];

export const delegatePackageCodeList = {
  StatusArray: Status,
  StatusMap: Status.reduce((acc, cur) => {
    return { ...acc, [cur.value]: cur };
  }, {}),
  TypeArray: Type,
  TypeMap: Type.reduce((acc, cur) => {
    return { ...acc, [cur.value]: cur };
  }, {})
};
